import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Modal } from 'react-responsive-modal';
import DesignCardFilter from '../DesignCard/DesignCardFilter/DesignCardFilter';
import CommunityImg from '../CommunityImg/CommunityImg';
import { default as pinrest } from '../../../images/pinrest.svg';
import 'react-responsive-modal/styles.css';
import './EventPartnerModal.scss';

const EventPartnerModal = ({
	isOpen,
	onClose,
	eventPartner,
  isCreativeCommunity,
  communityProfileLink,
  isIndustryExperts
}) => {

	const [open, setOpen] = useState(isOpen);
	const {
    getInTouchButtonLink ,
    getInTouchButtonText ,
    instagramProfileLink ,
    partnerDescription,
    partnerHeroImages,
    partnerLogo,
    partnerName,
    caseStudyButtonLink,
    caseStudyButtonText,
    facebookProfileLink,
    pinterestProfileLink,
    contentful_id,
    partnerProfileUrlSlug,
    partnerCountry,
    partnerSpeciality,
    partnerType,
    websiteLink
  } = eventPartner;

  useEffect(() => {
    document.body.parentElement.style.overflow = 'hidden';
    return () => {
      document.body.parentElement.style.overflow = 'auto';
    }
  }, []);

  const profileURLSlug = partnerProfileUrlSlug || contentful_id;
	const eventPartnerLogoImg = partnerLogo?.file?.url;
  const partnerSpecialityTags = partnerSpeciality?.length ? [...partnerSpeciality] : [];

  const onCloseModal = () => {
		onClose();
		setOpen(false); 
	}

	const openLink = link => {
    if(link){
      if(link.includes('@')) {
        window.location.assign(`mailto:${link}`);
      } else {
        window.open(`${link}`, '_blank', 'noopener');
      }
    }
  }

  const copyLink = link => {
    let urlNode = 'events-hub';
    
    if(partnerType === 'Creative Community') {
      urlNode = `creative`;
    } else if(partnerType === 'Industry Experts') {
      urlNode = `industry`;
    }

    copyToClipboard(`${window.location.origin}/community/${urlNode}/partner${link}`);
  }

  const copyToClipboard = (content) => {
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    toast.info("Link copied to clipboard", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  };

	return (
		<Modal open={open} onClose={onCloseModal} 
      classNames={{root : `event-partner-modal ${isCreativeCommunity && 'design-card'} ${isIndustryExperts ? 'industry-Expert' : ''}`}} center
      >
			<div className="event-partner-modal-breadcrumb" tabIndex="0">
				<span className="event-partner-modal-breadcrumb-title">{isCreativeCommunity ? 'Creative Community' : 'Events Hub'} {'>'}</span>
				<span className="event-partner-modal-breadcrumb-subtitle">{partnerName}</span>
			</div>
			<div className="event-partner-modal-container">
				<div className="event-partner-modal-left">
					<div className="event-partner-modal-image">
						<CommunityImg src={partnerHeroImages[0].file.url} alt="event" />
					</div>
				</div>
				<div className="event-partner-modal-right">
          <div className="event-partner-company-details">
            <div className="calender-card-footer-company">
              <div className="calender-card-footer-company-logo event-partner-logo" style={{ backgroundImage: `url(${eventPartnerLogoImg})` }} />
              <div className="calender-card-footer-company-detail">
                <div className="calender-card-footer-company-title">{partnerName}</div>
                <div className="calender-card-footer-company-location">{partnerCountry}</div>
              </div>
            </div>
            <div className="upcoming-event-details-footer-tags event-partner-tags">
              {
                partnerSpecialityTags.map((tags, idx) => {
                  return <span key={tags}>{tags}</span>
                })
              }
            </div>
          </div>
          <div className="upcoming-event-details-footer-separator company-section" />
					<div className="event-partner-modal-description">
						<pre>
							{partnerDescription?.partnerDescription}
						</pre>
					</div>
          {isCreativeCommunity && <div className="upcoming-event-details-footer-separator company-section creative-community" />}
					<div className={`upcoming-event-details-footer-button ${isCreativeCommunity && 'design-card-btn'}`}>
            {
              getInTouchButtonLink &&
              <button 
                className="upcoming-event-details-footer-button rsvpBtn" 
                onClick={()=>openLink(getInTouchButtonLink)}>
                  {getInTouchButtonText || 'Get In Touch'}
              </button>
            }
            {
              caseStudyButtonLink && 
              <button 
                className="upcoming-event-details-footer-button learnBtn" 
                onClick={()=>openLink(caseStudyButtonLink)}>
                  {caseStudyButtonText || 'Case Study'}
              </button>
            }
					</div>
					<div className="upcoming-event-details-footer-social-media">
            {
              websiteLink &&
                <div className="upcoming-event-details-footer-weblink-div">
                  <span className="upcoming-event-details-footer-social-span">Website: </span>
                  <span className="upcoming-event-details-footer-weblink-span" onClick={() => openLink(websiteLink)}>{websiteLink}</span>
                </div>
            }
						<span className="upcoming-event-details-footer-social-span">{isCreativeCommunity ? 'View Portfolio:' : 'Learn More:'}</span>
						{
							facebookProfileLink && 
                <i 
                onClick={()=>openLink(facebookProfileLink)}
                className={`fa fa-facebook upcoming-event-details-footer-social-media-svg`} 
                style={{fontSize : '15px'}}>
                </i>
						}
						{
							instagramProfileLink && 
              <i 
                onClick={()=>openLink(instagramProfileLink)}
                className={`fa fa-instagram upcoming-event-details-footer-social-media-svg`} 
                style={{fontSize : '15px'}}>
                </i>
              
            }
            {
							pinterestProfileLink && 
              <i 
                onClick={()=>openLink(pinterestProfileLink)}
                className={`fa fa-pinterest upcoming-event-details-footer-social-media-svg`} 
                style={{fontSize : '15px'}}>
              </i>
              
            }

						<CommunityImg 
              className="upcoming-event-details-footer-social-media-svg pinrest" 
              src={pinrest} 
              alt='pinrest'
              onClick={()=>copyLink(`/${profileURLSlug}`)}
              role="presentation"
            />

					</div>
				</div>
			</div>
      {
        isCreativeCommunity && !isIndustryExperts && communityProfileLink && <>
          <DesignCardFilter 
            communityProfileLink={communityProfileLink}
            partnerName={partnerName}
          />
          {/* <div className="partner-modal-designs-container">
              <DesignCard designs={communityProfileLink} isModal={true} />
          </div> */}
        </>
      }
		</Modal>
	);
};

export default EventPartnerModal;